// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".loading-message{margin-top:20px;width:100%}", "",{"version":3,"sources":["webpack://./src/chatbot/components/MessageTypes/LoadingMessage/loading-message.scss"],"names":[],"mappings":"AAAA,iBACE,eAAA,CACA,UAAA","sourcesContent":[".loading-message {\n  margin-top: 20px;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
